module.exports = __webpack_public_path__ + "static/media/chevron-right-primary.cb4026e4.svg";